import React from 'react';
import './index.style.less';
import { DotLoader } from 'react-spinners';

export const AppSpin = () => (
  <span className='loader-c'>
    <DotLoader color='#e38989' />
  </span>
);
